// src/components/Spinner.jsx
import React from 'react';

export default function Spinner() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <div className="spinner" style={{
        margin: "auto",
        border: "4px solid #eee",
        borderTop: "4px solid #555",
        borderRadius: "50%",
        width: 40,
        height: 40,
        animation: "spin 1s linear infinite"
      }} />
      <style>
      {`@keyframes spin { 100% { transform: rotate(360deg); } }`}
      </style>
      <div>Loading...</div>
    </div>
  );
}
